/** Display labels for the contact card status field. */
export const STATUS_LABELS = {
    pending: "En attente",
    accepted: "Accepté",
    declined: "Refusé",
    canceled: "Annulé",
    expired: "Expiré",
};

/** Chakra Badge colorScheme mapped to each contact card status. */
export const STATUS_SCHEME = {
    pending: "orange",
    accepted: "green",
    declined: "red",
    canceled: "gray",
    expired: "gray",
};

export const DEFAULT_STATUS_SCHEME = "gray";

/** Number of items per page returned by the API (hardcoded server-side). */
export const CONTACT_CARDS_PAGE_SIZE = 20;

/** Search debounce delay (ms). */
export const SEARCH_DEBOUNCE_MS = 300;
